// Port of api/fuel/app/classes/filter/search/games/filters/query/game/base.php
export default {
	name: 'game.base',
	priority: 95,
	require: function(config, filter) { return filter.base && filter.base.length > 0 },
	run: function(config, filter, data, query) {
		query.where('x.game_relation_parent', 'in', filter.base)
		query.order('g.game_sortname', false, 1000)
	}
}
